import { Component } from 'react';

class Counter extends Component {
    constructor(props) {
        super(props);

        this.increment = this.increment.bind(this);
        this.decrement = this.decrement.bind(this);
        this.changeCount = this.changeCount.bind(this);
        this.step = props.step ?? 1;
        this.minValue = props.minValue ?? 1;
        this.maxValue = props.maxValue ?? Infinity;
    }

    increment() {
        if (this.props.disabled) return;
        const value = Number(this.props.value) + Number(this.step);
        if (value >= this.minValue && value <= this.maxValue) {
            this.props.onChange?.(value);
        }
    }

    decrement() {
        if (this.props.disabled) return;
        const value = Number(this.props.value) - Number(this.step);
        if (value >= this.minValue) {
            this.props.onChange?.(value);
        }
    }

    changeCount(value) {
        // Allow an empty field so the user can clear it and retype a new number.
        if (value === '') {
            this.props.onChange?.(value);
            return;
        }
        const numeric = Number(value);
        if (Number.isNaN(numeric)) return;
        const clamped = Math.min(Math.max(numeric, this.minValue), this.maxValue);
        this.props.onChange?.(clamped);
    }

    render() {
        return (
            <div className="counter-item">
                <button onClick={this.decrement}>
                    <img src="/static/img/Minus.svg" alt="Decrement" />
                </button>
                <input
                    type="number"
                    value={this.props.value}
                    onChange={(e) => this.changeCount(e.target.value)}
                    style={this.props.inputStyle ?? {}}
                    onBlur={this.props.onBlur ?? (() => {})}
                    disabled={this.props.disabled ?? false}
                />
                <button onClick={this.increment}>
                    <img src="/static/img/Plus.svg" alt="Increment" />
                </button>
            </div>
        );
    }
}

export default Counter;
